export const app = {
  connectToYourWhatsappNumber: 'अपने व्हाट्सएप नंबर से कनेक्ट करें',
  connectYourWhatsappBotWithYourWhatsappNumber: 'अपने व्हाट्सएप बॉट को अपने व्हाट्सएप नंबर से कनेक्ट करें',
  connect: 'कनेक्ट करें',
};
